<div class="fluid-container">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title p-0">
            <h5 class="mb-0">{{ data?.stepName || 'Letter Generation' }}</h5>
            <p class="mb-0" style="font-size:14px">Add details for letter egenration</p>
        </div>

        <div class="col-md-4 editBtn headerSubPortion px-0">
            <ul>
                <li class="col-auto px-0 firstPortion">
                    <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
                </li>
                <li class="col-auto pr-0 pl-2 secondPortion">
                    <lib-maximize-dialog-library
                        [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
                    <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 p-0">
            <lib-assigning-task-library [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="main-body footer-adjust-v2">
        <div class="row mt-2">
            <div class="card card-min no-border">
                <div class="im-card-tab-menu">
                    <div class="im-list-group leftSidebar ml-0">
                        <!-- <a class="im-list-group-item" (click)="handleFormsGeneration()"
                            [ngClass]="{'activeItem': selectedItem === 0 , 'inActiveItem':  selectedItem !== 0 }">
                            <span>Forms</span></a> -->
                        <a class="im-list-group-item" (click)="handleCoverLetterSelection()"
                            [ngClass]="{'activeItem': selectedItem === 1 , 'inActiveItem':  selectedItem !== 1 }">
                            <span>Cover Letter</span></a>
                        <a class="im-list-group-item" (click)="handleSupoortLetterSelection()"
                            [ngClass]="{'activeItem': selectedItem === 2 , 'inActiveItem':  selectedItem !== 2 }"><span>Support
                                Letter</span></a>
                        <a class="im-list-group-item" (click)="handleOrganizeDocumentSelection()"
                            [ngClass]="{'activeItem': selectedItem === 3, 'inActiveItem':  selectedItem !== 3 }"><span>Organize
                                Documents</span></a>
                    </div>
                </div>
            </div>
            <div class="col-md pl-0 pr-0 ">
                <ng-template style="width:100%;" dynamicComponentPlaceHolder></ng-template>
            </div>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="row pt-3" *ngIf="isLastTab">
        <div class="col-md-6"></div>
        <div class="col-md-6">
            <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
        </div>
    </div>
    <div class="row pt-2" *ngIf="!isLastTab">
        <span style="color: #6c6666; font-size: 14px;">
            <i class="pi pi-info-circle pr-2" style="color: #19A0DA;"></i>This step can be marked complete when you
            reach the last tab, i.e., Organize Documents
        </span>
    </div>
</div>